import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { SvgIcon } from "../SvgIcon";
export var Maestro = function Maestro(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Maestro_svg__Maestro_svg__clip0_20336_109081)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.063 20a9.375 9.375 0 11-18.75 0 9.375 9.375 0 1118.75 0z",
    fill: "#00A1DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.75 20A9.375 9.375 0 115 20a9.375 9.375 0 1118.75 0z",
    fill: "#EA001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.531 27.831a9.367 9.367 0 004.219-7.83 9.367 9.367 0 00-4.219-7.832A9.367 9.367 0 0015.313 20a9.367 9.367 0 004.218 7.831z",
    fill: "#7673C0"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Maestro_svg__Maestro_svg__clip0_20336_109081"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  }))));
};
export default Maestro;